<portal-icon-button
  [disabled]="data()?.length < 1"
  [iconClass]="this.iconMapping[this.selectionDescription]"
  [portalTippy]="
    (allSelected ? 'datatable.selectMode.deselectAll' : 'datatable.selectMode.selectAll') | translate
  "
  (onClick)="toggleAll()"
  buttonClass="btn btn-icon btn--portal-link p-1"
>
</portal-icon-button>
